@if (initialized()) {
  <div #wrapperDiv (resized)="onWrapperDivResized($event)">
    <p-panel id="drift-status-panel" [styleClass]="urlParams().hideHeader ? 'no-header' : ''">
      <p-header>
        <h2 class="p-panel-title font-bold mb-0">{{ title() }}</h2>
      </p-header>

      <main class="pt-3">
        @if (!loading() && currentWebMessagesModel() && !urlParams().permaLinkURL) {
          @if (currentWebMessagesModel().canSeeFromArchive) {
            <div class="flex flex-column md:flex-row gap-3 mb-3">
              <div class="flex gap-2">
                <p-radioButton
                  name="onlyActiveOrInactive"
                  #showActiveCb
                  [value]="false"
                  tabindex="0"
                  inputId="showActiveCb"
                  [(ngModel)]="showFromArchive"
                  (onClick)="onShowActiveOrInActiveChanged(false)"
                  labelStyleClass="drift-body-text"
                />
                <label for="showActiveCb" translate>iFrame.driftStatus.ShowActiveMessages</label>
              </div>
              <div class="flex gap-2">
                <p-radioButton
                  name="onlyActiveOrInactive"
                  #showInactiveCb
                  [value]="true"
                  tabindex="1"
                  inputId="showInactiveCb"
                  labelStyleClass="drift-body-text"
                  [(ngModel)]="showFromArchive"
                  (onClick)="onShowActiveOrInActiveChanged(true)"
                />
                <label for="showInactiveCb" translate [translateParams]="{ days: currentWebMessagesModel().numOfDaysBackArchive }">iFrame.driftStatus.ShowArchivedMessages</label>
              </div>
            </div>
          }

          @if (!urlParams().displayAllContent && currentWebMessagesModel().groupMessagesByProfile) {
            <div>
              @for (pWm of currentWebMessagesModel().profilesWithWebmessages; track pWm.title) {
                <bi-accordion
                  [attr.aria-label]="pWm.title"
                  [titleColor]="urlParams().mainColor"
                  [disabled]="pWm.webMessages.length === 0"
                  [hasContentPadding]="false"
                  [borderColor]="urlParams().borders && urlParams().borderColor ? urlParams().borderColor : 'transparent'"
                  [contentBackgroundColor]="urlParams().borderColor ? urlParams().borderColor : urlParams().mainColor"
                  #accordion
                  (onOpen)="onContentHeightChanged()"
                  (onClose)="onContentHeightChanged()"
                >
                  <ng-container header>
                    <div class="accordion-header-wrapper">
                      <span class="accordion-header-text accordion-header-text--fixedWidth pb-0" [style]="titleStyle()">{{ pWm.title }}</span>
                      <span class="accordion-header-text" [style]="titleStyle()"> - </span>
                      <span [style]="titleStyle()" class="accordion-header-text">
                        @switch (pWm.webMessages.length) {
                          @case (0) {
                            {{ currentWebMessagesModel().defaultTextNoMessages }}
                          }
                          @case (1) {
                            1 {{ "shared.OperationalDisturbanceLower" | translate }}
                            @if (pWm.hasCriticalMessages) {
                              <i class="fa-solid fa-exclamation-triangle"></i>
                            }
                          }
                          @default {
                            {{ "iFrame.driftStatus.DisturbancesCount" | translate: { count: pWm.webMessages.length } }}
                            @if (pWm.hasCriticalMessages) {
                              <i class="fa-solid fa-exclamation-triangle"></i>
                            }
                          }
                        }
                      </span>
                    </div>
                  </ng-container>
                  <!-- web messages goes here -->
                  @if (pWm.webMessages.length > 0) {
                    <div content>
                      @for (message of pWm.webMessages; track message.id) {
                        <p-card class="webmessage-card">
                          @if (message.completed) {
                            <i class="fas fa-check-circle is-closed-icon"></i>
                          }
                          <h3 class="drift-message-title">
                            {{ message.title }}
                            @if (message.criticalStatus) {
                              <i class="fas fa-exclamation-triangle"></i>
                            }
                          </h3>
                          @if (!urlParams().hideDates) {
                            <ng-container>
                              <table>
                                <tr>
                                  <td class="font-bold drift-body-text" style="border-right: 1em solid transparent" translate>shared.Start<span>:</span></td>
                                  <td class="drift-body-text">
                                    {{ message.dateDelayUtc | biDayJs: dateTimeFormat() }}
                                  </td>
                                </tr>
                                @if (!urlParams().hideEndDates) {
                                  <tr>
                                    <td class="font-bold drift-body-text" style="border-right: 1em solid transparent" translate>shared.End<span>:</span></td>
                                    <td class="drift-body-text">
                                      {{ message.dateExpireUtc | biDayJs: dateTimeFormat() }}
                                    </td>
                                  </tr>
                                }
                              </table>
                            </ng-container>
                          }
                          <hr />
                          <p class="drift-body-text" [innerHTML]="message.text"></p>
                        </p-card>
                      }
                    </div>
                  }
                </bi-accordion>
              }
            </div>
          } @else if (!noMessagesToShow()) {
            @for (pWm of currentWebMessagesModel().profilesWithWebmessages; track pWm.title) {
              <div #profileWebMessage>
                @if (!urlParams().hideProfiles && currentWebMessagesModel().groupMessagesByProfile) {
                  <h3 [style]="titleStyle()">{{ pWm.title }}</h3>
                  <hr />
                }
                @for (message of pWm.webMessages; track message.id) {
                  <p-card class="webmessage-card">
                    <h4 class="drift-message-title">
                      {{ message.title }}
                      @if (message.criticalStatus && !urlParams().hideIndicator) {
                        <i class="fas fa-exclamation-triangle"></i>
                      }
                    </h4>
                    @if (!urlParams().hideDates) {
                      <p class="drift-body-text">
                        <span class="font-bold" translate>shared.Start</span>:
                        {{ message.dateDelayUtc | biDayJs: dateTimeFormat() }}
                      </p>
                      @if (!urlParams().hideEndDates) {
                        <p class="drift-body-text">
                          <span class="font-bold" translate>shared.End</span>:
                          {{ message.dateExpireUtc | biDayJs: dateTimeFormat() }}
                        </p>
                      }
                    }
                    <p class="drift-body-text" [innerHTML]="message.text"></p>
                  </p-card>
                }
              </div>
            }
          } @else {
            <span class="drift-body-text">{{ currentWebMessagesModel().defaultTextNoMessages }}</span>
          }
        }

        @if (urlParams().permaLinkURL) {
          @if (urlParams().showIndicator) {
            <p-badge class="mr-2" [value]="messageCount() | number: '1.0-0'" [severity]="messageCount() > 0 ? 'danger' : 'success'" />
          }
          <span [innerHTML]="'iFrame.driftStatus.PermalinkText' | translate: { permaLink: urlParams().permaLinkURL }"> </span>
        }

        <!-- Message to display if no "WebMessageModuleProfileMappings" has been found (e.i. no profiles set up) -->
        @if ((!loading() && !currentWebMessagesModel()?.profilesWithWebmessages) || currentWebMessagesModel()?.profilesWithWebmessages.length === 0) {
          <p-card>
            <div class="text-center">
              <i class="fas fa-ban bi-color-invalid fa-3x"></i>
              <div class="mt-3" role="alert" aria-atomic="true" translate>iFrame.driftStatus.NoProfilesSetUp</div>
            </div>
          </p-card>
        }
        @if (loading()) {
          <bi-spinner [centerInParent]="true" spinnerSize="large" />
        }
      </main>
    </p-panel>
  </div>
} @else {
  <bi-spinner [centerInParent]="true" class="mt-5" />
}
